/* unplugin-vue-components disabled */import { render } from "./BudgetItem.vue?vue&type=template&id=74fb524a&scoped=true&ts=true"
import script from "./BudgetItem.vue?vue&type=script&lang=ts"
export * from "./BudgetItem.vue?vue&type=script&lang=ts"

import "./BudgetItem.vue?vue&type=style&index=0&id=74fb524a&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fb524a"]])

export default __exports__